import React, { Component } from "react";
import { Accordion, Button, Label, Segment, Table } from "semantic-ui-react";
import PropTypes from "prop-types";
import api from "../../api";


class OrderPanels extends Component {


    render() {

        const groupedOrders = this.groupBy(Object.values(this.props.orders), "supplier_id");
        const orderPanels = Object.keys(groupedOrders)
            .map((key) => {
                const panel = {
                    key: "panel-" + key,
                    title: this.getSupplierById(key).name,
                    content: {
                        key: "panelContent" + key,
                        content: <div key={key}>
                            <Button onClick={() => {
                                api.createOrder(key, groupedOrders[key]);
                            }
                            }>Create Order</Button>
                            <Table>
                                <Table.Header fullWidth>
                                    <Table.Row>
                                        <Table.HeaderCell>Code</Table.HeaderCell>
                                        <Table.HeaderCell>Name</Table.HeaderCell>
                                        <Table.HeaderCell>Cost</Table.HeaderCell>
                                        <Table.HeaderCell>Amount</Table.HeaderCell>
                                        <Table.HeaderCell>Total</Table.HeaderCell>
                                        <Table.HeaderCell>Action</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {groupedOrders[key].map((row) => {
                                        return <Table.Row key={row.id}>
                                            <Table.Cell>{row.code}</Table.Cell>
                                            <Table.Cell>{(row.supplierCode + " " + row.name).trim()}</Table.Cell>
                                            <Table.Cell>{row.cost}</Table.Cell>
                                            <Table.Cell>{row.amount}</Table.Cell>
                                            <Table.Cell>{row.cost * row.amount}</Table.Cell>
                                            <Table.Cell><Button negative onClick={() => {
                                                this.props.removeProductOnOrder(row.id);
                                            }}>Remove</Button></Table.Cell>
                                        </Table.Row>;
                                    })}

                                </Table.Body>
                                <Table.Footer>
                                    <Table.Row>
                                        <Table.HeaderCell>Total</Table.HeaderCell>
                                        <Table.HeaderCell/>
                                        <Table.HeaderCell/>
                                        <Table.HeaderCell>{groupedOrders[key].reduce((a, b) => {
                                            return Number.parseInt(b.amount, 10) + a;
                                        }, 0)}</Table.HeaderCell>
                                        <Table.HeaderCell>{groupedOrders[key].reduce((a, b) => {
                                            return a + (Number.parseInt(b.amount, 10) * Number.parseInt(b.cost, 10));
                                        }, 0)}</Table.HeaderCell>
                                        <Table.HeaderCell/>
                                    </Table.Row>
                                </Table.Footer>
                            </Table>
                        </div>
                    }
                };

                return panel;

            });

        return (<div>
            <Segment>
                <Label attached='top'>Bestellungen</Label>
                <Accordion
                    exclusive={true}
                    styled
                    fluid
                    panels={orderPanels}/>
            </Segment>
        </div>);

    }


    groupBy(xs, key) {
        return xs.reduce(function (rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    };

    getSupplierById(id) {
        return this.props.suppliers.reduce((a, b) => {
            if (Number.parseInt(b.id, 10) === Number.parseInt(id, 10)) {
                return b;
            }
            return a;
        }, {});
    }


}


OrderPanels.propTypes = {
    orders: PropTypes.object.isRequired,
    suppliers: PropTypes.array.isRequired,
    removeProductOnOrder: PropTypes.func.isRequired
};


export default OrderPanels;



// WEBPACK FOOTER //
// ./src/scenes/Tools/scenes/Procurement/components/OrderPanels/index.js